import React, { Component } from "react";
import { message, Select, Popconfirm } from "antd";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, SelectItem, DatePickerItem, TextAreaItem, SwitchItem, MensajeError } from "../../../../Components/Items";

const REFRESCO_MS = 30 * 1000;

const duracion = (desde, hasta = moment()) => {
  const minutos = Math.max(0, moment(hasta).diff(moment(desde), "minutes"));
  const horas = Math.floor(minutos / 60);
  return horas > 0 ? `${horas}h ${minutos % 60}m` : `${minutos}m`;
};

const nombreCompleto = (u) => (u ? [u.nombre, u.apellidoPaterno, u.apellidoMaterno].filter(Boolean).join(" ") : "");

const estadoModalVacio = { codigoId: undefined, yaTermino: false, fechaParo: null, fechaArranque: null, observaciones: "" };

class BotonParoLineaPU extends Component {
  state = { loading: false, paro: null, codigos: [], modalParo: false, modalArranque: false, ...estadoModalVacio, ahora: moment() };

  componentDidMount() {
    this.consultar();
    this.intervalo = setInterval(this.consultar, REFRESCO_MS);
    this.reloj = setInterval(() => this.setState({ ahora: moment() }), 15 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalo);
    clearInterval(this.reloj);
  }

  post = (ruta, datos) => axios.post(`tiemposMuertosPU/${ruta}`, { empresaId: this.props.empresaId, ...datos }, { headers: this.props.headersToken });

  consultar = () =>
    this.post("paroActivo", {})
      .then((res) => res.data.success === 2 && this.setState({ paro: res.data.paro || null, ahora: moment() }))
      .catch(() => {});

  abrirParo = () => {
    this.setState({ modalParo: true, ...estadoModalVacio, fechaParo: moment(), fechaArranque: moment() });
    this.post("listarCodigos", { soloActivos: true })
      .then((res) => res.data.success === 2 && this.setState({ codigos: res.data.codigos || [] }))
      .catch(() => MensajeError({ message: "Error al cargar los códigos de tiempo muerto" }));
  };

  abrirArranque = () => this.setState({ modalArranque: true, fechaArranque: moment(), observaciones: "" });

  terminar = (res, texto) => {
    this.setState({ loading: false });
    if (res.data.success === 2) {
      message.success(texto);
      this.setState({ modalParo: false, modalArranque: false });
      this.consultar();
      this.props.onCambio && this.props.onCambio();
    } else {
      MensajeError({ message: res.data.error || "No se pudo guardar el paro" });
    }
  };

  fallo = () => {
    this.setState({ loading: false });
    MensajeError({ message: "Error al conectar con el servidor" });
  };

  guardarParo = () => {
    const { codigoId, yaTermino, fechaParo, fechaArranque, observaciones } = this.state;
    if (!codigoId) {
      MensajeError({ message: "Elige el código del paro" });
      return;
    }
    this.setState({ loading: true });
    const base = { usuarioId: this.props.usuarioId, codigoId, observaciones, fechaParo: fechaParo.toDate() };
    const peticion = yaTermino ? this.post("registrarParo", { ...base, fechaArranque: fechaArranque.toDate() }) : this.post("iniciarParo", base);
    peticion.then((res) => this.terminar(res, yaTermino ? "Paro registrado" : "Paro iniciado")).catch(this.fallo);
  };

  arrancar = () => {
    this.setState({ loading: true });
    this.post("arrancarParo", { usuarioId: this.props.usuarioId, paroId: this.state.paro._id, fechaArranque: this.state.fechaArranque.toDate(), observaciones: this.state.observaciones })
      .then((res) => this.terminar(res, "Línea arrancada"))
      .catch(this.fallo);
  };

  cancelar = () => {
    this.setState({ loading: true });
    this.post("cancelarParo", { usuarioId: this.props.usuarioId, paroId: this.state.paro._id })
      .then((res) => this.terminar(res, "Paro cancelado"))
      .catch(this.fallo);
  };

  campoFecha = (campo, etiqueta) => (
    <>
      <div style={{ margin: "12px 0 4px" }}>{etiqueta}</div>
      <DatePickerItem
        style={{ width: "100%" }}
        allowClear={false}
        showTime={{ format: "HH:mm" }}
        format="DD/MM/YYYY HH:mm"
        inputReadOnly
        value={this.state[campo]}
        disabledDate={(d) => d && d.isAfter(moment(), "day")}
        onSelect={(valor) => this.setState({ [campo]: valor })}
        onChange={(valor) => valor && this.setState({ [campo]: valor })}
      />
    </>
  );

  render() {
    const { paro, codigos, ahora } = this.state;
    const origenes = [...new Set(codigos.map((c) => c.origen))];

    return (
      <>
        {paro ? (
          <ButtonItem verde botonAncho icon={<PlayCircleOutlined />} onClick={this.abrirArranque}>
            Arranque · {paro.codigo} · {duracion(paro.fechaParo, ahora)}
          </ButtonItem>
        ) : (
          <ButtonItem rojo botonAncho icon={<PauseCircleOutlined />} onClick={this.abrirParo}>
            Paro de línea
          </ButtonItem>
        )}

        <ModalItem title="Paro de línea" visible={this.state.modalParo} spinning={this.state.loading} onCancel={() => this.setState({ modalParo: false })} width="40%" paddingTop>
          <div style={{ marginBottom: 4 }}>Código de tiempo muerto</div>
          <SelectItem
            placeholder="Elige el motivo del paro"
            width="100%"
            value={this.state.codigoId}
            onChange={(codigoId) => this.setState({ codigoId })}
          >
            {origenes.map((origen) => (
              <Select.OptGroup key={origen} label={origen}>
                {codigos
                  .filter((c) => c.origen === origen)
                  .map((c) => (
                    <Select.Option key={c._id} value={c._id}>
                      {`${c.codigo} - ${c.motivo}`}
                    </Select.Option>
                  ))}
              </Select.OptGroup>
            ))}
          </SelectItem>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
            <SwitchItem checked={this.state.yaTermino} onChange={(yaTermino) => this.setState({ yaTermino })} />
            <span>El paro ya terminó (registrar uno pasado)</span>
          </div>
          {this.campoFecha("fechaParo", "Hora de paro")}
          {this.state.yaTermino && this.campoFecha("fechaArranque", "Hora de arranque")}
          <div style={{ margin: "12px 0 4px" }}>Observaciones</div>
          <TextAreaItem placeholder="Opcional" value={this.state.observaciones} onChange={(e) => this.setState({ observaciones: e.target.value })} />
          <ButtonItem type="primary" style={{ display: "block", margin: "16px 0 0 auto" }} onClick={this.guardarParo}>
            {this.state.yaTermino ? "Registrar paro" : "Iniciar paro"}
          </ButtonItem>
        </ModalItem>

        <ModalItem title="Arrancar línea" visible={this.state.modalArranque} spinning={this.state.loading} onCancel={() => this.setState({ modalArranque: false })} width="40%" paddingTop>
          {paro && (
            <>
              <div style={{ padding: "10px 14px", borderRadius: 8, background: "#fff1f0", marginBottom: 8 }}>
                <b>
                  {paro.codigo} - {paro.motivo}
                </b>{" "}
                ({paro.origen})
                <div style={{ fontSize: 12, color: "#595959" }}>
                  Paro desde {moment(paro.fechaParo).format("DD/MM/YYYY HH:mm")} · {duracion(paro.fechaParo, ahora)} · {nombreCompleto(paro.usuarioId)}
                </div>
                {paro.observaciones && <div style={{ fontSize: 12, color: "#595959" }}>{paro.observaciones}</div>}
              </div>
              {this.campoFecha("fechaArranque", "Hora de arranque")}
              <div style={{ margin: "12px 0 4px" }}>Observaciones</div>
              <TextAreaItem placeholder="Opcional" value={this.state.observaciones} onChange={(e) => this.setState({ observaciones: e.target.value })} />
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
                <Popconfirm title="¿Cancelar este paro? No contará como tiempo muerto." onConfirm={this.cancelar}>
                  <ButtonItem blanco>Cancelar paro</ButtonItem>
                </Popconfirm>
                <ButtonItem type="primary" onClick={this.arrancar}>
                  Arrancar
                </ButtonItem>
              </div>
            </>
          )}
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(BotonParoLineaPU);
